module.exports = __webpack_public_path__ + "static/media/th-diamond__arm.b14db975.svg";